export function createValidator(condition: boolean, errorMessage: string | React.ReactNode) {
    if (condition) {
        return Promise.reject(errorMessage);
    }
    return Promise.resolve();
}
